import React from "react";

const FavouriteFill = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18.001 5.426c3.759-3.346 9.566-3.235 13.187.362a9.466 9.466 0 0 1 .378 13.07L17.998 32.333 4.434 18.858a9.468 9.468 0 0 1 .377-13.07c3.624-3.593 9.42-3.713 13.19-.362Z"
            fill={fill}
        />
    </svg>
);

export default FavouriteFill;